import { useState, type InputHTMLAttributes } from "react";

export function CampoPassword(props: Omit<InputHTMLAttributes<HTMLInputElement>, "type">) {
  const [visibile, setVisibile] = useState(false);
  return (
    <span className="campo-password">
      <input {...props} type={visibile ? "text" : "password"} autoCapitalize="off" autoCorrect="off" spellCheck={false} />
      <button
        type="button"
        className="occhio-password"
        aria-label={visibile ? "Nascondi la password" : "Mostra la password"}
        aria-pressed={visibile}
        onClick={() => setVisibile((v) => !v)}
      >
        <svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
          <path d="M2 12s3.6-7 10-7 10 7 10 7-3.6 7-10 7S2 12 2 12z" />
          <circle cx="12" cy="12" r="3" />
          {visibile && <path d="M4 4l16 16" />}
        </svg>
      </button>
    </span>
  );
}
